import { createContext, useContext } from 'react';

export const TeamMemberActionConfigContext = createContext<{
  inCurrentPlan?: boolean;
}>({
  inCurrentPlan: false,
});

export const useTeamMemberActionConfig = () =>
  useContext(TeamMemberActionConfigContext);
